import { render, staticRenderFns } from "./leftColInfoD.vue?vue&type=template&id=4390e626"
import script from "./leftColInfoD.vue?vue&type=script&lang=js"
export * from "./leftColInfoD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports